import { Box, Button, Grid, useTheme } from "@mui/material";
import {
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedSnackbar,
	RouterLinkButton,
} from "@websential/cosmic-v20";
import {
	EnhancedButtonPrimeReactSeverity,
	useNavigateToLogout,
} from "../../../../common/Common";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../../common/constants";
import { IResponse, IServerError } from "../../../../models/common";
import { Link, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { EnhancedButtonPrimeReact } from "../../../EnhancedButtonPrimeReact";
import { IAppState } from "../../../../store/reducers";
import { IGetListRequest } from "../../../../models";
import { ITrustBank } from "../../../../models/DirectDeposit/TrustBank";
import { PrimeDataGrid } from "../../../PrimeDataGrid";
import { TrustBankService } from "../../../../services/DirectDeposit/TrustBankService";
import {
	setAppBarSelectedItem,
} from "../../../../store/actions";
import { setSelectedActivityLogActions } from "../../../../store/actions/activityLogActions";
import { setSelectedDrawerOptionsMenu } from "../../../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../../../store/actions/stickyNavBarActions";

// import { toSnake } from "common/methods";








// import { clearError } from "store/actions/viewStateActions";





// import { EnhancedDataGrid } from "../../EnhancedDataGrid";
// import { newData } from "services";
// import OnRowDelete from "./OnRowDelete";






// import { fetchTrustBankRequest } from "store/actions/getListActions";

export interface ITrustBankList { }
const TRUST_BANK_LIST_QUERY_KEY: any = "trust-banks-list";

const useTrustBanksList = (params: IGetListRequest) =>
	useQuery({
		queryKey: [TRUST_BANK_LIST_QUERY_KEY, params],
		queryFn: () => TrustBankService.getTrustBanksList(params),
		refetchOnWindowFocus: false
	});

export const TrustBankList: React.FC<ITrustBankList> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [selectedRowsValues, setSelectedRowsValues] = useState([]);

	// Bulk Delete
	const [bulkDelete, setBulkDelete] = useState<boolean>(false);
	const [bulkTrustBankId, setBulkTrustBankId] = useState<any>({});
	const [bulkTrustBankDelete, setBulkTrustBankDelete] =
		useState<boolean>(false);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "acc_title",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const { message, componentState } = useSelector(
		(state: IAppState) => state.viewState
	);
	const [openDialog, setDialogOpen] = useState(false);
	const [selectedIds, setSelectedIds] = useState("");
	const [statusValue, setStatusValue] = useState("");
	const [apiAction, setApiAction] = useState("");
	const [emptyList, setEmptyList] = useState(false);
	const [searchText, setSearchText] = useState({});
	const [zeroTrustBank, setzeroTrustBank] = useState<any>(true);

	// for delete row
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [trustBankId, setTrustBankId] = useState<any>(0);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField && requestParams.sortField === "resource.name"
					? "resource.firstName"
					: requestParams.sortField
						? requestParams.sortField
						: "resource.firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};
		// if (requestParams.sort) {
		//   const [sortBy, sortDirection] = requestParams.sort.split(",");
		//   dispatchParams.order_by = toSnake(sortBy);
		//   dispatchParams.order_direction = sortDirection;
		// }
		setQueryParams(dispatchParams);
	}, []);

	const { isPending, data } = useTrustBanksList(queryParams); //useQuery('trustBanks-list', TrustBankService.trustBankList, { refetchOnWindowFocus: false });
	const trustBankList: any = data;

	const onSearchButtonClicked = () => {
		setQueryParams(searchText);
		setzeroTrustBank(false);
	};

	const onRowEditClicked = useCallback((params: ITrustBank) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/direct-deposit/trust-bank/setup/${params.id}`;
		navigate(path);
	}, []);

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const deleteTrustBankField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			// deleteTrustBankById(comapnyId);
			setDialogOpen(false);

			// setSnackbarData({
			// 	open: true,
			// 	message: "TrustBank cannot be deleted!",
			// 	severity: "error",
			// });
			let delPayload: any = {
				trustBankId: trustBankId,
				navigateToLogout: navigateToLogout,
			};
			deleteTrustBankById(delPayload);
		}
	};
	const onRowDeleteClicked = useCallback((params: ITrustBank) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setTrustBankId(params.id);
	}, []);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteTrustBankById } = useMutation({
		mutationFn: TrustBankService.delTrust,
		onSuccess: (res: string | IServerError | IResponse | any) => {
			if (res) {
				// remove the cache of the TrustBank fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: res.message ? res.message : "Something went wrong.",
					severity: res.status === false ? "error" : "success",
				});

				return queryClient.invalidateQueries(TRUST_BANK_LIST_QUERY_KEY);
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	}
	);

	const onRowMultipleDeleteClicked = (params: any) => {
		let bulkDeletePayload = {
			comapnyIds: { comapnyIds: params },
		};
		setDialogOpen(true);
		setBulkDelete(true);
		setApiAction("delete");
		setBulkTrustBankId(bulkDeletePayload);
		setBulkTrustBankDelete(true);
	};

	const selectionToolbar = useCallback(
		(selectedItems: any) => {
			setSelectedIds(selectedItems);
			if (selectedItems.length) {
				return (
					<Box>
						{/* <Button
							onClick={() => onRowMultipleDeleteClicked(selectedItems)}
							variant="contained"
							color="error"
						>
							Delete
						</Button> */}
					</Box>
				);
			}
			return (
				<>
					{isAdminUser === 400 ? (
						<Box>
							{/* <RouterLinkButton to="/trustBanks/setup" text="Add TrustBank" /> */}
							{/* <EnhancedButtonPrimeReact
								label="Add TrustBank"
								raised
								severity={EnhancedButtonPrimeReactSeverity.Success}
								to="/trustBanks/setup"
							/> */}
						</Box>
					) : (
						<></>
					)}
				</>
			);
		},
		[selectedRowsValues]
	);

	const getColumnMinWidth = (field: any) => {
		const maxContentWidth = Math.max(
			...trustBankList?.items.map((row: any) => String(row[field]).length * 8)
		); // Assuming an average character width of 8px
		return maxContentWidth + 16; // Add some padding
	};

	const onClickHandler = (clickedRow: any) => {
		// dispatch(setSelectedTrustBank(clickedRow));
		// dispatch(setSelectedTrustBankName(clickedRow));
		// dispatch(setAppBarSelectedItem({ appBarSelectedItem: "Home" }));
	};

	const upadtedTrustBankListItems = useMemo(() => {
		return (
			trustBankList &&
			trustBankList.items &&
			trustBankList?.items.map((item: any) => ({
				...item,
				// accTitle: (
				// 	<Link
				// 		to={`/trustBanks/clients`}
				// 		className="no-underline"
				// 		style={{ color: theme.palette.primary.light }}
				// 		onClick={() => onClickHandler(item)}
				// 	>
				// 		{item.accTitle}
				// 	</Link>
				// ),
			}))
		);
	}, [trustBankList]);

	// use three steps scenario if have threen items from travel agency project
	const expandedLabels = ["Direct Deposit", "Trust Bank"];
	const expandedTrustBankListOrSetupItem = "List"; // Special case for "List" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Trust Bank" &&
				item.label === expandedTrustBankListOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedTrustBankListOrSetupItem && "/direct-deposit/trust-bank/list",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";

	return trustBankList &&
		trustBankList.items &&
		trustBankList.items.length === 0 &&
		isAdminUser === 400 &&
		zeroTrustBank === true ? (
		<EmptyList
			showImage={true}
			imagePath={image}
			heading={`There's nothing! Add TrustBank to proceed`}
			content={`You can add trustBank by directly clicking on add trustBank button.`}
			testId={"trustBank-empty-list"}
			showAddButton={true}
			addButtonLabel={"Add TrustBank"}
			navigateToAdd={"/trustBanks/setup"}
			showImportButton={false}
			showImportXmlButton={false}
		/>
	) : (
		<>
			<Grid
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
			>
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={
						deleteTrustBankField
					}
					cancelActionHandler={onCloseHandler}
					testId="trustBank-field-tab-confirmation-dialog"
				/>

				<PrimeDataGrid
					columns={trustBankList ? trustBankList.headerColumns : []}
					rows={
						trustBankList && upadtedTrustBankListItems
							? upadtedTrustBankListItems
							: []
					}
					showIndexColumn={true}
					showChecboxColumn={false}
					showSettingColumn={true}
					onRowEditClicked={onRowEditClicked}
					onRowDeleteClicked={onRowDeleteClicked}
					// onKeyFieldClickHandler={onKeyFieldClickHandler}
					isLoading={isPending || isDeleting}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						trustBankList && trustBankList.total ? trustBankList.total : 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					selectionToolbar={selectionToolbar}
					selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
					searchFieldPlaceholder={"Search..."}
					changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
						setzeroTrustBank(value)
					}
					pageTitle={"TrustBanks"}
				/>
			</Grid>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"trustBank-field-tab-list-snackbar"}
				open={snackbarData.open}
			/>
		</>
	);

};
